enum CustomerDogStatus {
    STATUS_ACTIVE = "active",
    STATUS_ON_BREAK = "on_break",
    STATUS_DISABLED = "disabled",
}

export default CustomerDogStatus;
